/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * FlexiPage Theme
	 * Cryonix.cz
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	var nav_1 = __webpack_require__(1);
	var email_1 = __webpack_require__(3);
	var styles_1 = __webpack_require__(4);
	var form_1 = __webpack_require__(5);
	var bindScrollState = function () {
	    var update = function () {
	        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	        if (scrollTop > 0 && !document.body.classList.contains('scrolled'))
	            document.body.classList.add('scrolled');
	        else if (scrollTop <= 0 && document.body.classList.contains('scrolled'))
	            document.body.classList.remove('scrolled');
	    };
	    window.addEventListener("scroll", update);
	};
	/**
	 * Binds lazy images which appears when loaded
	 */
	var bindLazyImages = function (parent, selector) {
	    if (parent === void 0) { parent = document.body; }
	    if (selector === void 0) { selector = "img.lazyload"; }
	    var bind = function (el) {
	        el.addEventListener("load", function () {
	            el.classList.add("loaded");
	        });
	        if (el.complete)
	            el.classList.add("loaded");
	    };
	    var elements = parent.querySelectorAll(selector);
	    for (var i = 0; i < elements.length; i++)
	        bind(elements.item(i));
	};
	window.addEventListener("load", function () {
	    nav_1.bindMenuElements();
	    bindScrollState();
	    email_1.rewriteEmails();
	    styles_1.bindMoreBlocks();
	    nav_1.bindAnchorNav();
	    form_1.bindForms();
	    bindLazyImages(undefined, "img.editor-content-image");
	});


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * FlexiPage Theme
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	var util_1 = __webpack_require__(2);
	var bindMenuOpen = function (btnEl) {
	    var menuEl = document.getElementById(btnEl.getAttribute('data-menu-id'));
	    if (!menuEl)
	        throw new Error("Target menu element not found.");
	    btnEl.addEventListener("click", function () {
	        menuEl.classList.add('opened');
	    });
	};
	var bindMenuClose = function (btnEl) {
	    var menuEl = document.getElementById(btnEl.getAttribute('data-menu-id'));
	    if (!menuEl)
	        throw new Error("Target menu element not found.");
	    btnEl.addEventListener("click", function () {
	        menuEl.classList.remove('opened');
	    });
	};
	function bindMenuElements() {
	    var navOpen = document.body.querySelectorAll(".menu-open");
	    var navClose = document.body.querySelectorAll(".menu-close");
	    for (var i = 0; i < navOpen.length; i++)
	        bindMenuOpen(navOpen.item(i));
	    for (var i = 0; i < navClose.length; i++)
	        bindMenuClose(navClose.item(i));
	}
	exports.bindMenuElements = bindMenuElements;
	;
	function bindAnchorNav() {
	    var handleNav = function (anchor, cb) {
	        if (cb === void 0) { cb = null; }
	        if (anchor.length > 0) {
	            //Parse parts
	            var parts = anchor.split(":");
	            var targetId = parts.shift();
	            var targetEl = document.getElementById(targetId);
	            if (!targetEl)
	                return;
	            //Parse setters
	            for (var i = 0; i < parts.length; i++) {
	                var args = parts[i].split("=", 2);
	                var input = targetEl.querySelector('*[name*="' + args[0] + '"]');
	                if (input)
	                    input.value = args[1];
	            }
	            util_1.scrollToElement(targetEl, 300, -69, cb);
	        }
	    };
	    var handleHash = function () {
	        handleNav(location.hash.substr(1));
	    };
	    var bindLink = function (linkEl) {
	        linkEl.addEventListener("click", function (ev) {
	            ev.preventDefault();
	            var anchorPos = linkEl.href.indexOf("#");
	            var anchor = linkEl.href.substr(anchorPos + 1);
	            handleNav(anchor, function () {
	                var scroll = document.body.scrollTop || document.documentElement.scrollTop;
	                location.href = linkEl.href;
	                document.body.scrollTop = scroll;
	                document.documentElement.scrollTop = scroll;
	            });
	            return false;
	        });
	    };
	    window.onhashchange = handleHash;
	    var links = document.querySelectorAll('a[href^="#"]');
	    for (var i = 0; i < links.length; i++)
	        bindLink(links.item(i));
	    setTimeout(function () {
	        handleHash();
	    }, 200);
	}
	exports.bindAnchorNav = bindAnchorNav;
	;


/***/ },
/* 2 */
/***/ function(module, exports) {

	/**
	 * FlexiPage Theme
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	function getAbsolutePos(el) {
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var docElem = document.documentElement;
	    var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
	    var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
	    var clientTop = docElem.clientTop || body.clientTop || 0;
	    var clientLeft = docElem.clientLeft || body.clientLeft || 0;
	    var top = box.top + scrollTop - clientTop;
	    var left = box.left + scrollLeft - clientLeft;
	    return { top: Math.round(top), left: Math.round(left) };
	}
	exports.getAbsolutePos = getAbsolutePos;
	function scrollToElement(element, duration, offset, callback) {
	    if (duration === void 0) { duration = 1000; }
	    if (offset === void 0) { offset = 0; }
	    if (callback === void 0) { callback = null; }
	    var start = document.body.scrollTop || document.documentElement.scrollTop;
	    var change = Math.max(0, (getAbsolutePos(element).top + offset)) - start;
	    var currentTime = 0;
	    var increment = 20;
	    var canceled = false;
	    //Update duration
	    duration = Math.round((Math.abs(change) / 1000) * duration + 500);
	    var ease = function (t, b, c, d) { t /= d / 2; if (t < 1)
	        return c / 2 * t * t + b; t--; return -c / 2 * (t * (t - 2) - 1) + b; };
	    var cancelScroll = function () {
	        window.removeEventListener("wheel", cancelScroll);
	        window.removeEventListener("keydown", cancelScroll);
	        window.removeEventListener("mousewheel", cancelScroll);
	        window.removeEventListener("touchstart", cancelScroll);
	        canceled = true;
	    };
	    var animateScroll = function () {
	        currentTime += increment;
	        var val = ease(currentTime, start, change, duration);
	        document.body.scrollTop = val;
	        document.documentElement.scrollTop = val;
	        if (currentTime < duration && !canceled) {
	            setTimeout(animateScroll, increment);
	        }
	        else {
	            if (callback)
	                callback();
	        }
	    };
	    window.addEventListener("wheel", cancelScroll);
	    window.addEventListener("keydown", cancelScroll);
	    window.addEventListener("mousewheel", cancelScroll);
	    window.addEventListener("touchstart", cancelScroll);
	    animateScroll();
	}
	exports.scrollToElement = scrollToElement;
	(function (HTTP_METHOD) {
	    HTTP_METHOD[HTTP_METHOD["GET"] = 0] = "GET";
	    HTTP_METHOD[HTTP_METHOD["POST"] = 1] = "POST";
	    HTTP_METHOD[HTTP_METHOD["PUT"] = 2] = "PUT";
	    HTTP_METHOD[HTTP_METHOD["DELETE"] = 3] = "DELETE";
	})(exports.HTTP_METHOD || (exports.HTTP_METHOD = {}));
	var HTTP_METHOD = exports.HTTP_METHOD;
	function httpRequest(method, path, query, data, cb) {
	    //Construct URL
	    var url = path;
	    if (query) {
	        var queryParts = [];
	        for (var i in query)
	            queryParts.push(encodeURIComponent(i) + "=" + encodeURIComponent(query[i]));
	        url += '?' + queryParts.join('&');
	    }
	    //Set method
	    var _method;
	    switch (method) {
	        case HTTP_METHOD.GET:
	            _method = 'GET';
	            break;
	        case HTTP_METHOD.POST:
	            _method = 'POST';
	            break;
	        case HTTP_METHOD.PUT:
	            _method = 'PUT';
	            break;
	        case HTTP_METHOD.DELETE:
	            _method = 'DELETE';
	            break;
	    }
	    //Create request
	    var oReq = new XMLHttpRequest();
	    oReq.open(_method, url, true);
	    //Bind listener
	    oReq.addEventListener("load", function () {
	        cb(null, oReq.responseText, oReq.status);
	    });
	    oReq.addEventListener("error", function (ev) {
	        cb(ev.error, null, null);
	    });
	    //Send
	    if (data instanceof FormData) {
	        oReq.send(data);
	    }
	    else if (data) {
	        oReq.setRequestHeader('Content-type', 'application/json');
	        oReq.send(JSON.stringify(data));
	    }
	    else {
	        oReq.send();
	    }
	}
	exports.httpRequest = httpRequest;
	function httpMethodFromString(method) {
	    switch (method.toUpperCase()) {
	        case 'GET': return HTTP_METHOD.GET;
	        case 'POST': return HTTP_METHOD.POST;
	        case 'PUT': return HTTP_METHOD.PUT;
	        case 'DELETE': return HTTP_METHOD.DELETE;
	    }
	}
	exports.httpMethodFromString = httpMethodFromString;
	function apiRequest(method, path, query, data, cb) {
	    httpRequest(method, path, query, data, function (err, data, status) {
	        if (err)
	            return cb(err, null, status);
	        try {
	            var res = JSON.parse(data);
	            if (res.error)
	                return cb(new Error(res.error), null, status);
	            return cb(null, res, status);
	        }
	        catch (e) {
	            return cb(e, null, status);
	        }
	    });
	}
	exports.apiRequest = apiRequest;
	;


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * FlexiPage Theme
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	function rewriteEmails() {
	    var rewriteLink = function (linkEl) {
	        var address = linkEl.innerText.replace(/(\(zavinac\)|&#64;)/g, '@');
	        var label = address.replace(/@/g, '&#64;');
	        linkEl.innerHTML = linkEl.innerHTML.replace(/[\w\.-_]+(\(zavinac\)|&#64;)[\w\.-_]+(\.[\w\.-_]+)?/, label);
	        linkEl.setAttribute('href', 'mailto:' + address.trim());
	    };
	    var links = document.body.querySelectorAll('a[href="#mail-link"]');
	    for (var i = 0; i < links.length; i++)
	        rewriteLink(links.item(i));
	}
	exports.rewriteEmails = rewriteEmails;
	;


/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * FlexiPage Theme
	 * Cryonix.cz
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	function bindMoreBlocks() {
	    var bindBlock = function (blockEl) {
	        var contentEl = blockEl.querySelector(".more-content");
	        var linkEl = blockEl.querySelector('a[href="#vice"]');
	        linkEl.addEventListener("click", function (ev) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            contentEl.classList.toggle('opened');
	            linkEl.classList.toggle('active');
	            return false;
	        });
	    };
	    var blocks = document.body.querySelectorAll(".more-block");
	    for (var i = 0; i < blocks.length; i++)
	        bindBlock(blocks.item(i));
	}
	exports.bindMoreBlocks = bindMoreBlocks;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * FlexiPage Theme
	 * Cryonix.cz
	 *
	 * @author Jiri Hybek <jiri@hybek.cz>
	 * @license Commercial
	 */
	"use strict";
	var util_1 = __webpack_require__(2);
	function bindForms() {
	    var bindForm = function (formEl) {
	        var working = false;
	        var submitBtn = formEl.querySelector("button[type=submit]");
	        var msgSuccess = formEl.querySelector(".form-messages .success");
	        var msgInvalid = formEl.querySelector(".form-messages .invalid");
	        var msgError = formEl.querySelector(".form-messages .error");
	        formEl.addEventListener("submit", function (ev) {
	            ev.stopPropagation();
	            ev.preventDefault();
	            //Prevent double-submit
	            if (working)
	                return false;
	            //Set state
	            working = true;
	            submitBtn.classList.add('loading');
	            submitBtn.setAttribute('disabled', 'disabled');
	            //Remove message classes
	            msgSuccess.classList.remove('active');
	            msgInvalid.classList.remove('active');
	            msgError.classList.remove('active');
	            //Prepare data
	            var data = new FormData(formEl);
	            //Send request
	            util_1.apiRequest(util_1.httpMethodFromString(formEl.method), formEl.action, null, data, function (err, res, code) {
	                working = false;
	                submitBtn.classList.remove('loading');
	                submitBtn.removeAttribute('disabled');
	                if (err && code >= 400 && code < 500)
	                    msgInvalid.classList.add('active');
	                else if (err)
	                    msgError.classList.add('active');
	                else
	                    msgSuccess.classList.add('active');
	            });
	            return false;
	        });
	    };
	    var forms = document.querySelectorAll("form.form-editor-form");
	    for (var i = 0; i < forms.length; i++)
	        bindForm(forms.item(i));
	}
	exports.bindForms = bindForms;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** ../public/theme/dist/template.js
 **/